import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import MemberAlreadySubscribedStep, {
	IMemberAlreadySubscribedStepPageContent,
} from '@ui/templates/MemberAlreadySubscribedStep';

import { keysToCamel } from '@utils/butter';

import { IFlowStepProps } from '@folx-types/flow-steps';

interface IMemberAlreadySubscribedStepPageProps extends IFlowStepProps {}

const MemberAlreadySubscribedStepPage: FC<IMemberAlreadySubscribedStepPageProps> = ({
	path,
	stepKey,
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-already-subscribed" }) {
				header
				body
				folx_link
				folx_href
				help_link
				help_href
			}
		}
	`);

	const refinedContent: IMemberAlreadySubscribedStepPageContent = keysToCamel(
		pageContent
	) as IMemberAlreadySubscribedStepPageContent;

	return <MemberAlreadySubscribedStep pageContent={refinedContent} path={path} stepKey={stepKey} />;
};

export default MemberAlreadySubscribedStepPage;
